import { useEffect, useState } from 'react';
import Bugsnag from '@bugsnag/js';
import { isAvailable, isFeatureEnabled, waitTillAvailable } from '@vp/ab-reader';
import { Criteria, validateAllCriteria } from './criteria';

export function useVistaFeatureFlag(flag: string, criteria: Criteria[]) {
    const [isFeatureGateEnabled, setIsFeatureGateEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const shouldCheckFeatureFlag = Boolean(flag) && validateAllCriteria(criteria);

    useEffect(() => {
        async function checkFeatureFlag() {
            setIsLoading(true);

            if (!shouldCheckFeatureFlag) {
                setIsLoading(false);
                setIsFeatureGateEnabled(false);
                return;
            }

            const available = await waitTillAvailable(3000);
            if (!available) {
                Bugsnag.notify(new Error('AB reader is not available'));
                setIsFeatureGateEnabled(false);
                setIsLoading(false);
                return;
            }

            setIsFeatureGateEnabled(isFeatureEnabled(flag));
            setIsLoading(false);
        }

        void checkFeatureFlag();
    }, [shouldCheckFeatureFlag, flag]);

    return { isLoading, isFeatureGateEnabled };
}

export function useVistaFeatureEnable() {
    const [isLoading, setIsLoading] = useState(() => !isAvailable());

    useEffect(() => {
        async function checkAvailability() {
            if (isAvailable()) {
                setIsLoading(false);
                return;
            }

            const available = await waitTillAvailable(3000);
            if (!available) {
                Bugsnag.notify(new Error('AB reader is not available'));
            }
            setIsLoading(false);
        }

        void checkAvailability();
    }, []);

    return { isLoading, isFeatureEnabled };
}
